/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_HealthInputs */

const cs_kn_health = /** @type {(inputs: Kn_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílené vyhledávání ČÚZK pro celou kancelář. Makléři se nepřihlašují zvlášť — klíče jsou dnes na serveru.`)
};

const en_kn_health = /** @type {(inputs: Kn_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared ČÚZK lookup for the whole office. Brokers do not log in individually — keys live on the server today.`)
};

/**
* | output |
* | --- |
* | "Shared ČÚZK lookup for the whole office. Brokers do not log in individually — keys live on the server today." |
*
* @param {Kn_HealthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health = /** @type {((inputs?: Kn_HealthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_HealthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health(inputs)
	return cs_kn_health(inputs)
});